module.exports = __webpack_public_path__ + "img/FATIMA NECKLACE PURPLE.7234f40.svg";